export const formatReadingTime = time => `${time} min read`;
